import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Button */}
        <Link 
          to="/" 
          className="inline-flex items-center text-[#00BCD4] hover:text-[#FFA726] mb-6 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Vissza a főoldalra
        </Link>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-8 mb-6">
          <h1 className="text-4xl font-bold mb-2">
            <span className="text-[#00BCD4]">Adatvédelmi</span>
            <span className="text-[#FFA726]"> Tájékoztató</span>
          </h1>
          <p className="text-gray-600">Adatkezelési Tájékoztató</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-lg max-w-none">
          <h2>1. Adatkezelő adatai</h2>
          <p>
            <strong>Név:</strong> Horváth Attila EV<br />
            <strong>Székhely:</strong> 2315 Szigethalom, Széchenyi u. 44<br />
            <strong>Adószám:</strong> 56589119-1-33<br />
            <strong>Email:</strong> maszek.ah37@gmail.com<br />
            <strong>Telefonszám:</strong> +36 30 951 7159
          </p>

          <h2>2. A kezelt adatok köre</h2>
          <p>A szolgáltató az alábbi személyes adatokat kezelheti:</p>
          <ul>
            <li>Név</li>
            <li>Telefonszám</li>
            <li>Email cím</li>
            <li>Szállítási cím</li>
            <li>Rendelési adatok</li>
          </ul>

          <h2>3. Az adatkezelés célja</h2>
          <p>A személyes adatok kezelésének célja:</p>
          <ul>
            <li>A rendelés teljesítése</li>
            <li>Kapcsolattartás a vásárlóval</li>
            <li>Kiszállítás megszervezése</li>
            <li>Panaszkezelés</li>
            <li>Jogszabályi kötelezettségek teljesítése</li>
          </ul>

          <h2>4. Az adatkezelés jogalapja</h2>
          <p>Az adatkezelés jogalapja:</p>
          <ul>
            <li>Szerződés teljesítése</li>
            <li>Jogi kötelezettség teljesítése</li>
            <li>Jogos érdek, amennyiben alkalmazható</li>
          </ul>

          <h2>5. Adattovábbítás</h2>
          <p>
            A szolgáltató a rendelés teljesítése érdekében a szükséges adatokat 
            átadhatja a futár vagy kiszállítást végző személy részére.
          </p>
          <p>
            Az adattovábbítás kizárólag a rendelés teljesítéséhez szükséges 
            adatokra korlátozódik.
          </p>

          <h2>6. Adatmegőrzés ideje</h2>
          <p>
            A szolgáltató a személyes adatokat a rendelés teljesítéséhez szükséges ideig, 
            illetve a vonatkozó jogszabályokban előírt ideig őrzi meg.
          </p>

          <h2>7. Analitika és követés</h2>
          <p>A szolgáltató jelenleg <strong>nem használ</strong>:</p>
          <ul>
            <li>Google Analytics</li>
            <li>Facebook Pixel</li>
          </ul>

          <h2>8. Érintetti jogok</h2>
          <p>Az érintett jogosult:</p>
          <ul>
            <li>Tájékoztatást kérni az adatkezelésről</li>
            <li>Hozzáférést kérni a kezelt adatokhoz</li>
            <li>Kérni az adatok helyesbítését</li>
            <li>Kérni az adatok törlését, ha annak jogszabályi feltételei fennállnak</li>
            <li>Tiltakozni az adatkezelés ellen, ha annak jogalapja ezt lehetővé teszi</li>
          </ul>

          <h2>9. Jogérvényesítési lehetőségek</h2>
          <p>
            Az érintett panasszal élhet a <strong>Nemzeti Adatvédelmi és Információszabadság 
            Hatóságnál</strong>, illetve <strong>bírósághoz fordulhat</strong>.
          </p>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 my-4">
            <p className="text-sm text-blue-800 mb-0">
              <strong>Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</strong><br />
              Cím: 1055 Budapest, Falk Miksa utca 9-11.<br />
              Telefon: +36 1 391 1400<br />
              Email: ugyfelszolgalat@naih.hu<br />
              Weboldal: www.naih.hu
            </p>
          </div>

          <h2>10. Allergén információk</h2>
          <p>
            A szolgáltató jelenleg <strong>nem tesz közzé külön allergén listát</strong> a weboldalon.
          </p>
          <p className="text-sm text-gray-600">
            Kérjük, allergiás étkezés esetén a rendeléskor jelezze igényét telefonon: 
            <a href="tel:+36309517159" className="text-[#00BCD4] hover:text-[#FFA726]"> +36 30 951 7159</a>
          </p>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              <strong>Kapcsolat adatvédelmi kérdésekben:</strong><br />
              Horváth Attila EV<br />
              2315 Szigethalom, Széchenyi u. 44<br />
              Email: maszek.ah37@gmail.com<br />
              Telefon: +36 30 951 7159
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
